import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { WorkFormContext } from '../work-form.types';

type FormWithEmploymentTypeCheckboxes = {
  isFreelance: boolean | undefined;
  isTempwork: boolean | undefined;
  isEmployee: boolean | undefined;
  mutableUntilHours: string | undefined;
  hourlyRate: string | undefined;
  cla: string | undefined;
};

export const useFormEmploymentCheckboxes = () => {
  const { trigger, unregister } = useFormContext<FormWithEmploymentTypeCheckboxes>();
  const { setValue } = useFormContext<WorkFormContext>();

  const triggerEmployementCheckboxes = useCallback(async () => {
    await Promise.all([trigger('isFreelance'), trigger('isTempwork'), trigger('isEmployee')]);
  }, []);

  const triggerFreelanceCheckbox = useCallback(async () => {
    triggerEmployementCheckboxes();
    unregister('mutableUntilHours');
    unregister('hourlyRate');
    await Promise.all([trigger('mutableUntilHours'), trigger('hourlyRate')]);
    setValue('visibilityRules', []);
  }, []);

  const triggerTempworkCheckbox = useCallback(async () => {
    triggerEmployementCheckboxes();
    unregister('cla');
    await trigger('cla');
    setValue('visibilityRules', []);
  }, []);

  const triggerEmployeeCheckbox = useCallback(async () => {
    triggerEmployementCheckboxes();
    await Promise.all([trigger('mutableUntilHours'), trigger('hourlyRate'), trigger('cla')]);
    setValue('visibilityRules', []);
  }, []);

  return {
    triggerFreelanceCheckbox,
    triggerTempworkCheckbox,
    triggerEmployeeCheckbox,
  };
};
